var _path, _path2, _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDisabledIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.5 21.75C43.5 9.73781 33.7622 0 21.75 0C9.73781 0 0 9.73781 0 21.75C0 33.7622 9.73781 43.5 21.75 43.5C33.7622 43.5 43.5 33.7622 43.5 21.75Z",
    fill: "url(#paint0_linear_1044_8338)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.75 39C31.2769 39 39 31.2769 39 21.75C39 12.2231 31.2769 4.5 21.75 4.5C12.2231 4.5 4.5 12.2231 4.5 21.75C4.5 31.2769 12.2231 39 21.75 39Z",
    fill: "#DDDDDD"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1044_8338",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 10,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 10,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1044_8338)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 32C20.6167 32 19.3167 31.7375 18.1 31.2125C16.8833 30.6875 15.825 29.975 14.925 29.075C14.025 28.175 13.3125 27.1167 12.7875 25.9C12.2625 24.6833 12 23.3833 12 22C12 20.6167 12.2625 19.3167 12.7875 18.1C13.3125 16.8833 14.025 15.825 14.925 14.925C15.825 14.025 16.8833 13.3125 18.1 12.7875C19.3167 12.2625 20.6167 12 22 12C23.3833 12 24.6833 12.2625 25.9 12.7875C27.1167 13.3125 28.175 14.025 29.075 14.925C29.975 15.825 30.6875 16.8833 31.2125 18.1C31.7375 19.3167 32 20.6167 32 22C32 23.3833 31.7375 24.6833 31.2125 25.9C30.6875 27.1167 29.975 28.175 29.075 29.075C28.175 29.975 27.1167 30.6875 25.9 31.2125C24.6833 31.7375 23.3833 32 22 32ZM22 30C22.9 30 23.7667 29.8542 24.6 29.5625C25.4333 29.2708 26.2 28.85 26.9 28.3L15.7 17.1C15.15 17.8 14.7292 18.5667 14.4375 19.4C14.1458 20.2333 14 21.1 14 22C14 24.2333 14.775 26.125 16.325 27.675C17.875 29.225 19.7667 30 22 30ZM28.3 26.9C28.85 26.2 29.2708 25.4333 29.5625 24.6C29.8542 23.7667 30 22.9 30 22C30 19.7667 29.225 17.875 27.675 16.325C26.125 14.775 24.2333 14 22 14C21.1 14 20.2333 14.1458 19.4 14.4375C18.5667 14.7292 17.8 15.15 17.1 15.7L28.3 26.9Z",
    fill: "#1C1B1F"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1044_8338",
    x1: -5.25,
    y1: 21,
    x2: 53.25,
    y2: 21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.462301,
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFBFBF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabledIcon);
export default __webpack_public_path__ + "static/media/DisabledIcon.cfa6e1a195d7e7437d1df8980a9ca3aa.svg";
export { ForwardRef as ReactComponent };